import { BLITZLESEN_PRESENTATION_LATENCY_MS } from "@calega/realtime";

export const BLITZLESEN_PRESENTATION_LEAD_TIME_MS = BLITZLESEN_PRESENTATION_LATENCY_MS;

export interface BlitzlesenPresentationWindow {
  displayStartsAt: number;
  displayUntil: number;
}

export function scheduleBlitzlesenPresentation(
  serverNow: number,
  displayDurationMs: number,
): BlitzlesenPresentationWindow {
  const displayStartsAt = serverNow + BLITZLESEN_PRESENTATION_LEAD_TIME_MS;
  return {
    displayStartsAt,
    displayUntil: displayStartsAt + displayDurationMs,
  };
}

export function isBlitzlesenWordVisible(
  window: BlitzlesenPresentationWindow,
  serverNow: number,
) {
  return serverNow >= window.displayStartsAt && serverNow < window.displayUntil;
}

export function shouldEnterBlitzlesenRating(phase: string, canControl: boolean) {
  return phase === "showing" && canControl;
}

export function newestFirst<T>(entries: readonly T[]) {
  return [...entries].reverse();
}
